<template>
  <div class="redeem">
    <redeem-flow :offer="$route.params.offer" />
    <illustration-mosaic />
  </div>
</template>

<script>
import windowStore from '@/store/modules/window.store'

export default {
  name: 'checkout',
  beforeRouteEnter(to, from, next) {
    if (windowStore.state.countryCode !== 'BR') {
      return next({ name: 'inactive' })
    }

    next()
  }
}
</script>

<style lang="scss" scoped>
.redeem {
  display: flex;
  justify-content: space-between;
  min-height: 100vh;
  background: $login-background;

  & > .illustration-mosaic {
    display: none;
  }

  @media screen and (min-width: 768px) {
    & > .illustration-mosaic {
      display: inline-flex;
    }
  }
}
</style>
